import { Component, h } from "preact";

interface ILabelSvgSpriteState {
  element: JSX.Element;
}

export default class LabelSvgSprite extends Component<
  ILabelSvgSpriteProps,
  ILabelSvgSpriteState
> {
  get url(): string {
    return (
      this.props.conf.asset_prefix +
      "assets/sprites/label-assets-sprite.svg#" +
      this.props.imageCode
    );
  }

  componentDidMount(): void {
    setTimeout(
      () =>
        this.setState({
          element: this.renderElement(),
        }),
      100,
    );
  }

  componentDidUpdate(previousProps: Readonly<ILabelSvgSpriteProps>): void {
    if (
      this.props.conf.asset_prefix === previousProps.conf.asset_prefix &&
      this.props.imageCode === previousProps.imageCode
    ) {
      return;
    }
    setTimeout(
      () =>
        this.setState({
          element: this.renderElement(),
        }),
      100,
    );
  }

  renderElement(): JSX.Element {
    return (
      <svg
        role="image"
        className={this.props.cssClass}
        viewBox={this.props.viewBox || null}
        alt={this.props.alt}
      >
        <use xlinkHref={this.url} />
      </svg>
    );
  }

  render(): JSX.Element {
    return this.state.element;
  }
}

interface ILabelSvgSpriteProps {
  imageCode: string;
  viewBox?: string;
  cssClass?: string;
  conf: any;
  multicolorImage: boolean;
  alt?: string;
}
